<template>
  <div class="app-login">
    <el-container>
      <el-header style="padding: 0">
        <div class="login-top" style="width: 100%;height: 30px;background-color: #666">
          <p
            style="font-family: Microsoft YaHei,SimHei,Arial,Verdana,Vrinda,Tahoma,serif;margin: 0;display: inline-block;font-size: 10pt;line-height: 30px;color: white;float: left">
            &nbsp;&nbsp; FOHOW Electronic Commerce System
          </p>
        </div>
      </el-header>
      <el-main>
        <div style="width: 800px;margin: 0 auto;overflow: hidden;">
          <div style="width: 100%;height: 150px;float: right;">
            <div style="width: 50%;height: 40%;margin-top:100px;float: right;">
              <p style="font-weight: 600;color:#F39F43;text-align: left;margin: 15px 0 0 5px;font-size: 30px;">
                {{ activeName === 'agent' ? $t('webapp.name.agent') : $t('webapp.name.member') }}</p>
            </div>
          </div>
          <div style="width: 60%;float: right;">
            <div style="width: 88%;float: right">
              <div class="login-wrapper">
                <el-form ref="loginForm" :model="login" :rules="rules" class="login-form" label-position="left">
                  <div>
                    <el-form-item>
                      <el-select :class="{ 'en': isEn }" v-model="selectedlanguage" @change="handleLang(selectedlanguage)"
                        value-key="code" style="width: 100%">
                        <el-option v-for="item in languages" :key="item.code" :label="item.title" :value="item" />
                        <span slot="prefix" class="ipt-label">{{ $t('language') }}</span>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="username">
                      <el-input v-model.trim="login.username" :class="{ 'en': isEn }" :placeholder="$t('login.id.input')">
                        <span slot="prefix" class="ipt-label">{{ $t('ps.find.login.code') }}</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                      <el-input v-model.trim="login.password" :class="{ 'en': isEn }" show-password
                        :placeholder="$t('login.pass.input')">
                        <span slot="prefix" class="ipt-label">{{ $t('mi.member.pwd') }}</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                      <div class="vcode">
                        <el-input v-model.trim="login.code" :class="{ 'en': isEn }" maxlength="4"
                          :placeholder="$t('me.inputyzm')" @keyup.enter.native="handleLogin">
                          <span slot="prefix" class="ipt-label" style="width: 20px;word-wrap:normal">{{
                            $t('sysUser.validateCode') }}</span>
                        </el-input>
                        <el-image fit="contain" :src="captcha.data" @click="handleRefresh">
                          <div slot="error" class="image-slot" @click="handleRefresh">
                            <i v-if="captchaLoading" class="el-icon-loading"></i>
                            <i v-else class="el-icon-refresh"></i>
                          </div>
                          <div slot="placeholder" class="image-slot"><i class="el-icon-loading"></i></div>
                        </el-image>
                      </div>
                    </el-form-item>
                    <el-form-item style="margin-bottom: 5px">
                      <el-button class="btn" :loading="loginLoading" @click="handleLogin">
                        {{ $t('operation.button.login') }}
                      </el-button>
                    </el-form-item>
                    <el-form-item v-show="activeName === 'member' && promotionTime">
                      <el-button :loading="loginLoading" class="btn" @click="inMemberRegister">
                        {{ $t('register.us.legend.member.register1') }}
                      </el-button>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
          <div
            style="position: absolute;left: 48%;top: 20%;width: 2px;height: 420px;border: none;background-image: linear-gradient(#FFF, #242424, #FFF)" />
          <div style="width: 40%;height: 400px;float: left;position: relative">
            <div class="deleteBorder" style="position: absolute;top: -10%;right: -20%">
              <el-tabs tab-position="left" v-model="activeName" style="transform: scale(0.7)">
                <!--经销商系统-->
                <el-tab-pane :label="$t('webapp.name.member')" name="member" />
                <!--代办处系统-->
                <el-tab-pane :label="$t('webapp.name.agent')" name="agent" />
              </el-tabs>
            </div>
            <img src="../../assets/images/foherb_logo.png" alt="logo"
              style="width: 360px;height: 260px;margin-top: 47px">
          </div>
        </div>
      </el-main>
      <el-footer style="padding: 0">
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { fetchCaptcha, afnAugustPromotion } from '@/api/home'
import { getLanguage } from '@/lang'
import Cookies from "js-cookie";

export default {
  name: 'Login',
  data() {
    var validatorUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('login.id.input') ? this.$t('login.id.input') : '请输入用户名'))
      } else {
        callback()
      }
    }
    var validatorPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('login.pass.input') ? this.$t('login.pass.input') : '请输入密码'))
      } else {
        callback()
      }
    }
    var validatorCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('me.inputyzm') ? this.$t('me.inputyzm') : '请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      promotionTime: false,
      recoveryObj: {
        userCode: '',
        email: '',
      },
      activeName: 'member',
      selectedlanguage: { code: 'zh_CN', title: 'Chinese' },
      radio: 'true',
      login: {
        username: undefined,
        password: undefined,
        code: undefined
      },
      rules: {
        username: [{ validator: validatorUsername, trigger: 'blur' }],
        password: [{ validator: validatorPassword, trigger: 'blur' }],
        code: [{ validator: validatorCode, trigger: 'blur' }],
      },
      loginLoading: false,
      captchaLoading: false,
      captcha: {
        data: '',
        key: ''
      },
      languages: [
        { code: 'zh_CN', title: 'Chinese 中文' },
        { code: 'en_GB', title: 'English 英语' },
        { code: 'fr_FR', title: 'French 法语' }
      ],
      redirect: undefined,
      otherQuery: {},
      mobile: '',
      sendLoading: false,
      send: false,
      time: 60
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    isEn() {
      return this.$store.getters.language !== 'zh_CN'
    },
    isAgent() {
      return this.activeName === 'agent'
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    },
    "login.username": function (val) {
      this.login.username = val.toUpperCase()
    }
  },
  created() {
    this.getPromotionTime()
  },
  mounted() {
    switch (Cookies.get('language')) {
      case 'zh_CN':
        this.selectedlanguage = { code: 'zh_CN', title: 'Chinese 中文' }
        break
      case 'en_GB':
        this.selectedlanguage = { code: 'en_GB', title: 'English 英语' }
        break
      case 'fr_FR':
        this.selectedlanguage = { code: 'fr_FR', title: 'French 法语' }
        break
      default:
        this.selectedlanguage = { code: 'en_GB', title: 'English 英语' }
    }
    this.$i18n.locale = this.selectedlanguage.code
    this.$store.dispatch('app/setLanguage', this.selectedlanguage.code)
    getLanguage()
    this.getCaptcha()
    setInterval(() => {
      this.getCaptcha()
    }, 120000)
  },
  methods: {
    getPromotionTime() {
      afnAugustPromotion().then(res => {
        this.promotionTime = res.data
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    getCaptcha() {
      this.captchaLoading = true
      this.captcha = {
        data: '',
        key: ''
      }
      fetchCaptcha().then(response => {
        this.captcha = response.data
        this.captchaLoading = false
      }).catch(() => {
        this.captchaLoading = false
      })
    },
    handleRefresh() {
      if (!this.captchaLoading) {
        this.getCaptcha()
      }
    },
    handleLang(lang) {
      this.$i18n.locale = lang.code
      this.$store.dispatch('app/setLanguage', lang.code)
      getLanguage()
      this.$router.go(0)
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const loginData = {
            userCode: this.login.username,
            password: this.login.password,
            captcha: this.login.code,
            captchaKey: this.captcha.key,
            smsCode: this.login.smsCode,
            isAgent: this.isAgent
          }
          // loginData.isAgent = loginData.userCode.length <= 8
          this.loginLoading = true
          this.$store.dispatch('user/login', loginData).then(() => {
            this.$store.dispatch('weeks/setWeeks')
            // this.$router.push({path: this.redirect || '/', query: this.otherQuery})
            this.$router.push({ path: '/' })
            this.loginLoading = false
          }).catch(() => {
            this.loginLoading = false
          })
        }
      })
    },
    inMemberRegister() {
      this.$router.push(`/inRegister?language=${this.selectedlanguage.code}`)
    }
  }
}
</script>

<style lang="scss">
.el-tabs__item.is-active {
  color: #F39F43 !important;
  font-size: 26px;
  font-weight: 600;
}

.el-tabs__item {
  color: #333;
  font-size: 22px;
}

.app-login .login-wrapper .login-form .en input {
  padding-left: 170px !important;
}

.el-form-item__content {
  display: flex;
}
</style>
